import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getExtractionJobStatistics } from '../services/api/extractionApi';
import { useAuth } from '../contexts/AuthContext';
import CustomerReviewDashboard from './CustomerReviewDashboard';
import { STATUS_DISPLAY, EXTRACTION_JOB_STATUS } from '../constants/statusConstants';
import { usePageBreadcrumbs } from '../hooks/usePageBreadcrumbs';

const Dashboard = () => {
  usePageBreadcrumbs([]);
  const [stats, setStats] = useState({
    total: 0,
    requested: 0,
    processing: 0,
    completed: 0,
    needsReview: 0,
    failed: 0,
    exporting: 0,
    exportedLast7Days: 0,
    exportFailed: 0,
    augmenting: 0,
    augmentationReview: 0,
    readyForExport: 0,
    augmentationFailed: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { hasPermission } = useAuth();

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const response = await getExtractionJobStatistics();
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      setError('Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="mb-4">Dashboard</h2>
      
      {error && <Alert variant="danger">{error}</Alert>}
      
      <Row className="mb-4">
        <Col md={12}>
          <Card>
            <Card.Body>
              <Card.Title>Extraction Job Statistics</Card.Title>
              <Row className="text-center mt-3">
                <Col>
                  <h3 className="text-primary">{stats.requested}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.REQUESTED]}</p>
                </Col>
                <Col>
                  <h3 className="text-info">{stats.processing}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.PROCESSING]}</p>
                </Col>
                <Col>
                  <h3 className="text-info">{stats.augmenting}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.AUGMENTING]}</p>
                </Col>
                <Col>
                  <h3 className="text-danger">{stats.augmentationFailed}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.AUGMENTATION_FAILED]}</p>
                </Col>
                <Col>
                  <h3 className="text-warning">{stats.augmentationReview}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.AUGMENTATION_REVIEW]}</p>
                </Col>
                <Col>
                  <h3 className="text-warning">{stats.needsReview}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.NEEDS_REVIEW]}</p>
                </Col>
                <Col>
                  <h3 className="text-success">{stats.readyForExport}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.READY_FOR_EXPORT]}</p>
                </Col>
                <Col>
                  <h3 className="text-success">{stats.completed}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.COMPLETED]}</p>
                </Col>
                <Col>
                  <h3 className="text-info">{stats.exporting}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.EXPORTING]}</p>
                </Col>
                <Col>
                  <h3 className="text-primary">{stats.exportedLast7Days}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.EXPORTED]} (7d)</p>
                </Col>
                <Col>
                  <h3 className="text-danger">{stats.failed}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.FAILED]}</p>
                </Col>
                <Col>
                  <h3 className="text-danger">{stats.exportFailed}</h3>
                  <p>{STATUS_DISPLAY[EXTRACTION_JOB_STATUS.EXPORT_FAILED]}</p>
                </Col>
                <Col>
                  <h3>{stats.total}</h3>
                  <p>Total</p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      {hasPermission('extractions', 'view') && (
        <Row className="mt-4">
          <Col md={12}>
            <CustomerReviewDashboard />
          </Col>
        </Row>
      )}
      
    </div>
  );
};

export default Dashboard;